import { getHistory } from '@/api/content';
import { ContentHistory, HistoryState } from '@/types/history';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type HistoryGetter = GetterTree<HistoryState, RootState>;

const state: HistoryState = {
  history: [],
  isLoading: false,
};

const getters: HistoryGetter = {
  history: state => state.history,
  isLoading: state => state.isLoading,
};

const actions: ActionTree<HistoryState, RootState> = {
  async getHistory({ commit, dispatch }, id: string): Promise<void> {
    commit('setLoading', true);
    try {
      const history = await getHistory(id);
      commit('setHistory', history);
    } catch (error: any) {
      const history = [
        {
          commit: '',
          date: Date.now(),
          message: '',
          author: 'Error fetching history',
        },
      ];
      commit('setHistory', history);
    }
    commit('setLoading', false);
  },
};

const mutations: MutationTree<HistoryState> = {
  setHistory(state: HistoryState, history: ContentHistory[]) {
    state.history = history;
  },
  setLoading(state: HistoryState, isLoading: boolean) {
    state.isLoading = isLoading;
  },
};

const history: Module<HistoryState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default history;
